import { PanelLeftClose, PanelLeft, MousePointerClick } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { SidebarTooltip } from './SidebarTooltip'
import type { SidebarMode } from '../../hooks/useSidebarState'

interface SidebarModeSelectorProps {
  mode: SidebarMode
  onModeChange: (mode: SidebarMode) => void
  isExpanded: boolean
}

const MODE_OPTIONS = [
  { value: 'expanded', label: 'Expandido', icon: PanelLeft },
  { value: 'collapsed', label: 'Colapsado', icon: PanelLeftClose },
  { value: 'hover', label: 'Expandir al pasar', icon: MousePointerClick },
] as const

export function SidebarModeSelector({
  mode,
  onModeChange,
  isExpanded,
}: SidebarModeSelectorProps) {
  const currentOption = MODE_OPTIONS.find((opt) => opt.value === mode)
  const CurrentIcon = currentOption?.icon || PanelLeft

  const trigger = (
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-muted-foreground hover:text-foreground"
      >
        <CurrentIcon className="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
  )

  return (
    <DropdownMenu>
      {!isExpanded ? (
        <SidebarTooltip content="Modo del sidebar" side="top">
          {trigger}
        </SidebarTooltip>
      ) : (
        trigger
      )}

      <DropdownMenuContent align="end" side="top" className="w-48">
        <DropdownMenuLabel>Modo del Sidebar</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup
          value={mode}
          onValueChange={(v) => onModeChange(v as SidebarMode)}
        >
          {MODE_OPTIONS.map((option) => {
            const Icon = option.icon
            return (
              <DropdownMenuRadioItem
                key={option.value}
                value={option.value}
                className="gap-2"
              >
                <Icon className="h-4 w-4" />
                {option.label}
              </DropdownMenuRadioItem>
            )
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
